module.exports = __webpack_public_path__ + "static/media/LsgIn.e262394f.png";